/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { DataState } from '../../types/common/DataState';
import { IProject } from '../../types/project/IProject';

export enum ProjectsActions {
  GET_USER_PROJECTS_WATCHER = 'GET_USER_PROJECTS_WATCHER',
  GET_USER_PROJECTS_FAILURE = 'GET_USER_PROJECTS_FAILURE',
  GET_USER_PROJECTS_REQUEST = 'GET_USER_PROJECTS_REQUEST',
  GET_USER_PROJECTS_SUCCESS = 'GET_USER_PROJECTS_SUCCESS',
}

export type ProjectsState = {
  isFetching: boolean;
  errorMessage?: string;
  items: IProject[];
  dataState: DataState;
};

type GetUserProjectsWatcherAction = {
  type: ProjectsActions.GET_USER_PROJECTS_WATCHER;
};
type GetUserProjectsRequestAction = {
  type: ProjectsActions.GET_USER_PROJECTS_REQUEST;
};
type GetUserProjectsSuccessAction = {
  type: ProjectsActions.GET_USER_PROJECTS_SUCCESS;
  payload: {
    items: IProject[];
  };
};
type GetUserProjectsErrorAction = {
  type: ProjectsActions.GET_USER_PROJECTS_FAILURE;
  payload: {
    errorMessage?: string;
  };
};

export type ProjectsActionTypes =
  | GetUserProjectsWatcherAction
  | GetUserProjectsRequestAction
  | GetUserProjectsSuccessAction
  | GetUserProjectsErrorAction;
